import { Divider, Typography } from "@commonlibs";
import {
    InnerCardNavigationBody,
    InnerCardNavigationHeader,
    InnerCardNavigationHeaderWrapper,
    InnerCardNavigationRoot,
} from "./InnerCardNavigation.styles";
import { InnerCardNavigationProps } from "./InnerCardNavigation.types";

function InnerCardNavigation({ children, divider, header: { title, ...headerProps } }: InnerCardNavigationProps) {
    return (
        <InnerCardNavigationRoot>
            <InnerCardNavigationHeaderWrapper>
                <InnerCardNavigationHeader
                    center={
                        typeof title === "string" ? (
                            <Typography variant="body1Strong" textTransform="uppercase">
                                {title}
                            </Typography>
                        ) : (
                            title
                        )
                    }
                    {...headerProps}
                />
                {divider && <Divider />}
            </InnerCardNavigationHeaderWrapper>
            <InnerCardNavigationBody className="inner-card-navigation-body">{children}</InnerCardNavigationBody>
        </InnerCardNavigationRoot>
    );
}

export default InnerCardNavigation;
